const ENDPOINTS = {
  local: "http://localhost:8080/api/v1/que-bendicion",
  prod: "https://api.que-bendicion.com/api/v1/que-bendicion",
};

export const API_ENDPOINT =
  process.env.NODE_ENV !== "production" ? ENDPOINTS.local : ENDPOINTS.prod;

export const ENDPOINT = {
  POST_LOGIN: `${API_ENDPOINT}/user/login`,
  POST_NEW_PRODUCT: `${API_ENDPOINT}/product`,
  POST_SALES_BY_DATES: `${API_ENDPOINT}/sale/completed-sales-by-date-range`,
  GET_PRODUCTS: `${API_ENDPOINT}/product`,
  PUT_UPDATE_PRODUCT: `${API_ENDPOINT}/product`,
  DEL_DELETE_PRODUCT: `${API_ENDPOINT}/product`,
  GET_PRODUCT_CATEGORIES: `${API_ENDPOINT}/product-category`,
  POST_NEW_SUPPLY: `${API_ENDPOINT}/supply`,
  GET_SUPPLIES: `${API_ENDPOINT}/supply`,
  PUT_UPDATE_SUPPLY: `${API_ENDPOINT}/supply`,
  DEL_DELETE_SUPPLY: `${API_ENDPOINT}/supply`,
  NEW_SALE: `${API_ENDPOINT}/sale`,
  OPEN_SALES: `${API_ENDPOINT}/sale/open-sale`,
  UPDATE_SALE: `${API_ENDPOINT}/sale`,
  POST_PAY_SALE: `${API_ENDPOINT}/sale/pay-open-sale`,
  POST_CANCEL_SALE: `${API_ENDPOINT}/sale/cancel-sale`,
  GET_PENDING_SALES: `${API_ENDPOINT}/sale/cashier-sale`,
  CLOSE_PENDING_SALES: `${API_ENDPOINT}/sale/complete-cashier-sales`,
  GET_EXPENSES: `${API_ENDPOINT}/expense/get-expenses-by-date`,
  NEW_EXPENSES: `${API_ENDPOINT}/expense`,
  NEW_INVOICE: `${API_ENDPOINT}/expense/invoice`,
  GET_INVOICE: `${API_ENDPOINT}/expense/invoice`,
  UPDATE_INVOICE: `${API_ENDPOINT}/expense/invoice`,
  DELETE_EXPENSES: `${API_ENDPOINT}/expense`,
  GET_EXPENSES_CATEGORIES: `${API_ENDPOINT}/expense-category`,
  POST_VOLUME_SUMMARY: `${API_ENDPOINT}/report/volume-summary`,
  POST_SALES_BY_CATEGORY: `${API_ENDPOINT}/report/sales-by-category`,
  POST_SALES_BY_PRODUCT: `${API_ENDPOINT}/report/sales-by-product`,
  POST_SALES_OVER_TIME: `${API_ENDPOINT}/report/sales-over-time`,
  POST_AVERAGE_TICKET: `${API_ENDPOINT}/report/average-order-value`,
  POST_LOCAL_VS_DELIVERY: `${API_ENDPOINT}/report/local-vs-delivery`,
  POST_TOP_PRODUCTS: `${API_ENDPOINT}/report/top-products`,
  POST_TOP_CATEGORIES: `${API_ENDPOINT}/report/top-product-categories`,
  GET_REPORT_EXPENSES_BY_CATEGORY: `${API_ENDPOINT}/report/expenses-by-category`,
  SEND_CASHIER_TELEGRAM: `${API_ENDPOINT}/telegram/send-cashier-summary`,
};
